export default __webpack_public_path__ + "static/media/Purchase_Success.89bc70f2.webp";